export type InitialView = 'anonymous' | 'expired' | 'game' | 'lobby';

/**
 * Pure boot-routing decision for the initial App load. Mirrors the branch
 * ladder in App's init effect exactly — the caller keeps every side effect
 * (emit(), dropToken()); this only names the destination view.
 *
 *   no token  + embedKey        → anonymous  (public browse)
 *   no token  + no embedKey     → expired
 *   token + walletError + embedKey    → anonymous  (caller drops the stale token)
 *   token + walletError + no embedKey → expired
 *   token + no walletError      → game if a gameId is present, else lobby
 */
export function decideInitialView({
  hasToken,
  hasEmbedKey,
  walletError,
  hasGameId,
}: {
  hasToken: boolean;
  hasEmbedKey: boolean;
  walletError: boolean;
  hasGameId: boolean;
}): InitialView {
  if (!hasToken) return hasEmbedKey ? 'anonymous' : 'expired';
  if (walletError) return hasEmbedKey ? 'anonymous' : 'expired';
  return hasGameId ? 'game' : 'lobby';
}

/**
 * Mid-session 401 expiry routing (the onSessionExpired handler). Embed
 * sessions fall back to anonymous browse; operator/partner sessions show
 * the Expired screen. The caller keeps the dropToken()/emit() side effects.
 */
export function decideExpiryView({
  hasEmbedKey,
}: {
  hasEmbedKey: boolean;
}): 'anonymous' | 'expired' {
  return hasEmbedKey ? 'anonymous' : 'expired';
}
